import { render, staticRenderFns } from "./ItemFilterOpenMyFilter.vue?vue&type=template&id=5877a44c&scoped=true"
import script from "./ItemFilterOpenMyFilter.vue?vue&type=script&lang=js"
export * from "./ItemFilterOpenMyFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5877a44c",
  null
  
)

export default component.exports